export const ValidationHelper = {
  namepattern: '^[A-Za-z ]+$',
  emailPattern: '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
  //passwordPattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{8,}$',
  passwordPattern: '^(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{7,}$',
  mobilePattern: '^((\\+91-?)|0)?[0-9]{10}$',
  order: '^[0-9]+$'
};
